// ============================================================================
// MOCK SHOWS DATA - Centralized mock data for development
// Will be replaced with API integration
// ============================================================================

import type { Show, ShowReference } from "@/types/show";

/**
 * Initial shows data for ShowsContext
 */
export const INITIAL_SHOWS: Show[] = [
  {
    id: "1",
    userId: "",
    payeeUserId: null,
    slug: "tech-talk-weekly",
    title: "Tech Talk Weekly",
    description: "A weekly dive into the latest technology trends, gadgets, and innovations shaping our digital future.",
    coverUrl: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=400&h=400&fit=crop",
    episodeCount: 47,
    lastPublished: "2024-12-15",
    status: "active",
    language: "en",
    category: "Technology",
    explicit: false,
    author: "Tech Talk Media",
    email: "contact@techtalkweekly.com",
    website: "https://techtalkweekly.com",
    rssFeedUrl: "https://rss.podgo.io/tech-talk-weekly",
    platforms: ["Spotify", "Apple Podcasts", "Google Podcasts", "Amazon Music"],
    subcategory: null,
    hostingPlatform: null,
    timezone: null,
    createdAt: "2024-01-15",
    youtubeUrl: null,
    facebookUrl: null,
    instagramUrl: null,
    xUrl: null,
    tiktokUrl: null,
    spotifyUrl: null,
    appleUrl: null,
    contractSignedAt: null,
    contractStatus: null,
    docusignEnvelopeId: null,
    contractRequired: false,
    simplecastShowId: null,
  },
  {
    id: "2",
    userId: "",
    payeeUserId: null,
    slug: "creator-stories",
    title: "Creator Stories",
    description: "Interviews with successful creators sharing their journeys, challenges, and lessons learned.",
    coverUrl: null,
    episodeCount: 23,
    lastPublished: "2024-12-12",
    status: "active",
    language: "en",
    category: "Business",
    explicit: false,
    author: "Creator Network",
    email: "hello@creatorstories.fm",
    website: "https://creatorstories.fm",
    rssFeedUrl: "https://rss.podgo.io/creator-stories",
    platforms: ["Spotify", "Apple Podcasts"],
    subcategory: null,
    hostingPlatform: null,
    timezone: null,
    createdAt: "2024-03-20",
    youtubeUrl: null,
    facebookUrl: null,
    instagramUrl: null,
    xUrl: null,
    tiktokUrl: null,
    spotifyUrl: null,
    appleUrl: null,
    contractSignedAt: null,
    contractStatus: null,
    docusignEnvelopeId: null,
    contractRequired: false,
    simplecastShowId: null,
  },
  {
    id: "3",
    userId: "",
    payeeUserId: null,
    slug: "podcast-growth-tips",
    title: "Podcast Growth Tips",
    description: "Tips, strategies, and insights for growing your podcast audience and building a sustainable show.",
    coverUrl: "https://images.unsplash.com/photo-1554200876-56c2f25224fa?w=400&h=400&fit=crop",
    episodeCount: 12,
    lastPublished: "2024-11-28",
    status: "paused",
    language: "en",
    category: "Education",
    explicit: false,
    author: "Growth Academy",
    email: "support@podcastgrowth.tips",
    website: "https://podcastgrowth.tips",
    rssFeedUrl: "https://rss.podgo.io/podcast-growth-tips",
    platforms: ["Spotify", "Apple Podcasts", "Google Podcasts"],
    subcategory: null,
    hostingPlatform: null,
    timezone: null,
    createdAt: "2024-06-10",
    youtubeUrl: null,
    facebookUrl: null,
    instagramUrl: null,
    xUrl: null,
    tiktokUrl: null,
    spotifyUrl: null,
    appleUrl: null,
    contractSignedAt: null,
    contractStatus: null,
    docusignEnvelopeId: null,
    contractRequired: false,
    simplecastShowId: null,
  },
];

/**
 * Show references for dropdowns and filters
 * Derived from INITIAL_SHOWS for consistency
 */
export const SHOW_REFERENCES: ShowReference[] = INITIAL_SHOWS.map((show) => ({
  id: show.id,
  title: show.title,
}));

